import { Directive, Injector, Input } from '@angular/core';
import { BusinessUnitModel } from '../../business-unit.model';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';
import { DataFieldHelperService } from '@fi-app/data-field/data-field-helper.service';

@Directive()
export class FiBusinessUnitViewProfileTabBase {
    @Input() businessUnit: BusinessUnitModel;
    @Input() businessUnitDataFields: DataFieldModel[];

    constructor(
        protected dataFieldHelperService: DataFieldHelperService,
        protected injector: Injector,
    ) {}

    getMatIconClass(dataField: DataFieldModel): string {
        return this.dataFieldHelperService.getProfileViewDataFieldsMatIconClass(dataField);
    }

    isBusinessUnitDataFieldShown(dataField: DataFieldModel): boolean {
        return this.dataFieldHelperService.isBusinessUnitDataFieldShownInProfileView(dataField, this.businessUnit);
    }
}
